import Cookies from 'js-cookie';
const md5 = require('md5-node');
const Base64 = require('js-base64').Base64;

const TokenKey = 'Portfolio-Token';
const InfoKey = 'Portfolio-Info';

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function getUserInfo() {
  const UserInfo = Cookies.get(InfoKey);
  if (UserInfo) {
    return JSON.parse(Cookies.get(InfoKey));
  } else {
    return UserInfo;
  }
}

export function setUserInfo(Info) {
  return Cookies.set(InfoKey, Info, { expires: 7 });
}

export function removeUserInfo() {
  return Cookies.remove(InfoKey);
}

export const genAuthorization = (queryObj) => {
  let result = '';
  let sortedKey = Object.keys(queryObj).sort();
  sortedKey.forEach((key) => {
    if (queryObj[key] instanceof Object) {
      queryObj[key] = JSON.stringify(queryObj[key]);
    }
    result += `${key}=${queryObj[key]}`;
  });
  result += '750cfcc8bce92d7bd96fef8a64983aa6';
  result = md5(result);
  result = `sccportfolio:${result}`;
  result = Base64.encode(result);
  return result;
};
